import React from "react"
import { concatStrings } from "../utilities"

const DfbParagraph = (props) => {
  const TagName = props.tagName || "p"
  const testid = props.testid ? props.testid : null
  return (
    <TagName
      className={concatStrings("dfb-Paragraph", props.add_class)}
      dangerouslySetInnerHTML={{ __html: props.text }}
      data-testid={testid}
    ></TagName>
  )
}
export default DfbParagraph
